import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {getBluejayTeam as onGetBluejayTeam} from "../../store/actions";
import Multiselect from 'multiselect-react-dropdown';
import { Row, Col, Button, Collapse } from 'reactstrap';
import Loader from "components/Loader/Loader";
import deployAlertsLottie from '../../assets/images/deploy_alerts_lottie.json';
import { showNotification } from "components/Common/notification";

import {
    getAlertOpenAndCloseWithin5Minutes as onGetAlertOpenAndCloseWithin5Minutes,
    getAlertOpenAndCloseWithin5MinutesCount as onGetAlertOpenAndCloseWithin5MinutesCount,
    getAlertLogCountByApplicationService as onGetAlertLogCountByApplicationService,
    getAlertLogCountByIntegrationType as onGetAlertLogCountByIntegrationType,
    getMostFrequentAlerts as onGetMostFrequentAlerts
} from "../../store/actions";

const AlertAnalyticsActions = ({ setSelectedTeamIds }) => {
    const dispatch = useDispatch();
    const [selectedTeamIdsLocal, setSelectedTeamIdsLocal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    function formatDate(date) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    let payload = { teamIds: [] }
    useEffect(() => {
        dispatch(onGetBluejayTeam());
    }, [dispatch]);
    useEffect(() => {
        dispatch(onGetAlertLogCountByApplicationService(payload));
    }, [onGetAlertLogCountByApplicationService])

    useEffect(() => {

        dispatch(onGetMostFrequentAlerts(payload));
    }, [onGetMostFrequentAlerts])

    useEffect(() => {

        dispatch(onGetAlertLogCountByIntegrationType(payload));
    }, [onGetAlertLogCountByIntegrationType])

    const { bluejay_teams } = useSelector(state => ({
        bluejay_teams: state.Organization.bluejay_teams
    }));

    // useEffect(() => {
    //     dispatch(getMostFrequentAlertsAzure(payload));
    // }, [getMostFrequentAlertsAzure]);

    const teamOptions = bluejay_teams.map(team => ({ id: team.id, name: team.name }));

    const onSelect = (selectedList, selectedItem) => {
        const updatedSelectedTeamIds = selectedList.map(item => item.id);
        setSelectedTeamIdsLocal(updatedSelectedTeamIds);
        setSelectedTeamIds(updatedSelectedTeamIds);
    };

    const onRemove = (selectedList, removedItem) => {
        const updatedSelectedTeamIds = selectedList.map(item => item.id);
        setSelectedTeamIdsLocal(updatedSelectedTeamIds);
        setSelectedTeamIds(updatedSelectedTeamIds);
    };

    const handleApplyFilter = () => {
        // setIsLoading(true);
        showNotification("success", "Fetched")
        const formattedStartDate = startDate ? formatDate(startDate) : '';
        const formattedEndDate = endDate ? formatDate(endDate) : '';
        const payload = {
            teamIds: selectedTeamIdsLocal,
            startDate: formattedStartDate,
            endDate: formattedEndDate
        };
        dispatch(onGetAlertOpenAndCloseWithin5Minutes(payload));
        dispatch(onGetAlertOpenAndCloseWithin5MinutesCount(payload));
        dispatch(onGetAlertLogCountByApplicationService(payload));
        dispatch(onGetAlertLogCountByIntegrationType(payload));
        dispatch(onGetMostFrequentAlerts(payload));
        // dispatch(getMostFrequentAlertsAzure(payload));
        {/*setTimeout(() => {
            setIsLoading(false);
        }, 2500);*/}
    };

    const handleStartDateChange = (event) => {
        const dateValue = event.target.value;
        setStartDate(dateValue ? new Date(dateValue) : null);
    };

    const handleEndDateChange = (event) => {
        const dateValue = event.target.value;
        const newEndDate = dateValue ? new Date(dateValue) : null;
        if (startDate && newEndDate && newEndDate < startDate) {
            showNotification("error", "End date cannot be before the start date")
            return;
        }
        setEndDate(newEndDate);
    };

    const toggle = () => {
        setIsSearching(prevState => !prevState);
    }

    return (
        <>
            <Row>
                <Col md="2">
                    <div className="position-relative hstack gap-3" style={{ marginBottom: '10px' }}>
                        <a href="#" onClick={toggle} className="btn btn-secondary w-100">
                            <i className="bx bx-filter-alt align-middle"></i> Search & Filter
                        </a>
                    </div>
                </Col>
            </Row>
            <Collapse isOpen={isSearching} id="filterCollapse">
                <Row>
                    <Row className="mb-3">
                        <Col md="1">
                            <label htmlFor="search-input" className="col-form-label">
                                Team(s):
                            </label>
                        </Col>
                        <Col md="3">
                            <div className="form-group">
                                <Multiselect
                                    id="team-select"
                                    name="team"
                                    options={teamOptions}
                                    displayValue="name"
                                    closeOnSelect={true}
                                    onSelect={onSelect}
                                    onRemove={onRemove}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col style={{fontWeight: "500"}} md={2} lg={2}>
                            Alerts Opened between
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={2} lg={2}>
                            <label
                                htmlFor="start-date-input"
                                className="col-form-label"
                            >
                                Start Date:
                            </label>
                        </Col>
                        <Col md={3} lg={3}>
                            <input
                                className="form-control text-white bg-transparent border border-white"
                                type="date"
                                placeholder='Start Date'
                                id="start-date-input"
                                value={startDate ? startDate.toISOString().split('T')[0] : ''}
                                onChange={handleStartDateChange}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col md={2} lg={2}>
                            <label
                                htmlFor="end-date-input"
                                className="col-form-label"
                            >
                                End Date:
                            </label>
                        </Col>
                        <Col md={3} lg={3}>
                            <input
                                className="form-control text-white bg-transparent border border-white"
                                type="date"
                                placeholder='End Date'
                                id="end-date-input"
                                value={endDate ? endDate.toISOString().split('T')[0] : ''}
                                onChange={handleEndDateChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <button type="button" className="btn btn-primary w-md" onClick={handleApplyFilter}>Submit</button>
                        </Col>
                    </Row>
                </Row>
            </Collapse>
        </>
    );
};

export default AlertAnalyticsActions;
